export default (state) => {
    const organizations = Object(state.organizations)
    const selected = organizations[state.currentOrganizationID]
    // Prefer the explicitly-selected org, but only if it's a real one with an id.
    // Otherwise fall back to the first org that actually has an id, so a stale /
    // phantom entry (e.g. a persisted {"undefined": {}}) can't make us resolve an
    // idless org and request /organizations/undefined/...
    const firstValid = Object.values(organizations).find((org) => org && org.id)
    return {
        ...state,
        currentOrganization: (selected && selected.id) ? selected : firstValid
    }
}